import { createGlobalStyle } from 'styled-components'
import { Pretendard } from '@/assets/fonts/pretendard'

const GlobalStyle = createGlobalStyle`
   ${Pretendard}

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Pretendard', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  `

export default GlobalStyle
